import type { SVGProps } from "react";
import { Icon, type IconProps } from "../Icon";
const InternalSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M6.08 15.464C4.257 15.344 3 14.477 3 12.712c0-1.619 1.63-3.183 3.302-3.25m0 0A2.58 2.58 0 0 1 8 10c2.034 1.555-.274 3.64-1.5 1.725-.374-.585-.423-1.4-.198-2.263m0 0c.513-1.963 2.44-4.167 5.163-4.437 3.918-.39 5.563 3.948 5.563 3.948s3.2-.27 3.44 2.752c.33 4.277-4.287 3.679-5.968 3.739"
    />
    <path
      strokeLinecap="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M11.578 12s-5.838 4.877-4.329 4.911 2.264-.136 1.628.75c-.635.887-1.339 2.882-.465 2.2.873-.649 4.754-3.973 3.92-3.973s-1.906 0-1.509-.375L14 12.784"
      style={{
        stroke: "var(--icon-accent,#E47B53)",
      }}
    />
  </svg>
);
export const AngerIcon = (props: IconProps) => (
  <Icon {...props} Icon={InternalSvg} />
);
